import { SummaryConfig } from "../../../hooks";
import { capitalizeFirst } from "../../../helper-functions";

export const dmekGradingSummaryConfig: SummaryConfig = {
    graft: [
        {
            accessor: "graft.graftSize",
            formatter: (val) => `Graft size: ${val} mm.`,
        },
        {
            accessor: "graft.scrollType",
            formatter: (val) => `Scroll type: ${val}.`,
        },
        {
            accessor: "graft.scrollTightness",
            renderer: (data) => {
                const { scrollTightness, scrollTightnessOther } = data.graft ?? {};
                return `Scroll Tightness: ${scrollTightness ?? ""}${scrollTightness === "other" ? `: ${scrollTightnessOther ?? ""}` : ""}.`;
            },
        },
        {
            accessor: "graft.transportTubeType",
            renderer: (data) => {
                const { transportTubeType, transportTubeTypeOther } = data.graft ?? {};
                return `Transport Tube Type: ${transportTubeType ?? ""}${transportTubeType === "other" ? `: ${transportTubeTypeOther ?? ""}` : ""}.`;
            },
        },
        {
            accessor: "graft.comments",
        },
    ],
    stroma: [
        {
            accessor: "stroma.na",
            renderer: (data) => {
                const { na, graftReadhered } = data.stroma ?? {};
                if (na) {
                    return "N/A.";
                }
                return {
                    "title": "Graft Readhered to Stroma",
                    "stroma.graftReadhered": capitalizeFirst(graftReadhered),
                };
            },
        },
        {
            accessor: "stroma.comments",
        },
    ],
    descemets: [
        {
            accessor: "descemets.checked",
            renderer: "Normal, DMEK Processed.",
        },
        {
            accessor: "descemets.sMark.checked",
            renderer: {
                "title": "'S' mark",
                "descemets.sMarkVisibility": "",
            },
        },
        {
            accessor: "descemets.fMark.checked",
            renderer: {
                "title": "'F' mark",
                "descemets.fMarkVisibility": "",
            },
        },
        {
            accessor: "descemets.orientation",
            renderer: "Orientation Notch.",
        },
        {
            accessor: "descemets.comments",
        },
    ],
    endothelium: [
        {
            accessor: "endothelium.polymegathism",
            defaultValue: false,
            formatter: (val) => (val ? "Polymegathism noted." : "Cells are uniform in size."),
        },
        {
            accessor: "endothelium.pleomorphism",
            defaultValue: false,
            formatter: (val) => (val ? "Pleomorphism noted." : "Cells are uniform in shape."),
        },
        {
            accessor: "endothelium.stressLines",
            renderer: (data) => {
                const { stressLines } = data?.endothelium ?? {};
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (stressLines && Object.values<any>(stressLines).some((v) => !!v)) {
                    return {
                        "title": "Stress Lines",
                        "endothelium.stressLines.quantity": "",
                        "endothelium.stressLines.severity": "",
                        "endothelium.stressLines.central": "Central",
                        "endothelium.stressLines.midPeriph": "Mid-Periph",
                        "endothelium.stressLines.periph": "Periph",
                        "endothelium.stressLines.diffuse": "Diffuse",
                    };
                }
                return "";
            },
        },
        {
            accessor: "endothelium.comments",
        },
    ],
};
